import request from '@/router/axios'

const urlPrefix = '/sys';

/**
 * 政策链接管理-列表
 * @param data
 */
export function linkList(data) {
  return request({
    url: urlPrefix + '/policy/manage/link/list',
    method: 'post',
    data
  })
}

/**
 * 政策链接管理-新增
 * @param data
 */
export function linkAdd(data) {
  return request({
    url: urlPrefix + '/policy/manage/link/add',
    method: 'post',
    data
  })
}

/**
 * 政策链接管理-编辑
 * @param data
 */
export function linkUpdate(data) {
  return request({
    url: urlPrefix + '/policy/manage/link/update',
    method: 'post',
    data
  })
}

/**
 * 政策链接管理-删除
 * @param data
 */
export function linkDel(data) {
  return request({
    url: urlPrefix + '/policy/manage/link/del',
    method: 'post',
    data
  })
}

/**
 * 政策库权限管理-列表
 * @param data
 */
export function authList(data) {
  return request({
    url: urlPrefix + '/policy/manage/auth/list',
    method: 'post',
    data
  })
}

/**
 * 政策库权限管理-编辑
 * @param data
 */
export function authUpdate(data) {
  return request({
    url: urlPrefix + '/policy/manage/auth/update',
    method: 'post',
    data
  })
}

/**
 * 政策速递邮件订阅管理-列表
 * @param data
 */
export function emailList(data) {
  return request({
    url: urlPrefix + '/policy/manage/email/list',
    method: 'post',
    data
  })
}

/**
 * 政策速递邮件订阅管理-编辑
 * @param data
 */
export function emailUpdate(data) {
  return request({
    url: urlPrefix + '/policy/manage/email/update',
    method: 'post',
    data
  })
}

/**
 * 行业报告管理-列表
 * @param data
 */
export function reportList(data) {
  return request({
    url: urlPrefix + '/policy/manage/report/list',
    method: 'post',
    data
  })
}

/**
 * 行业报告管理-上传
 * @param data
 */
export function reportAdd(data) {
  return request({
    url: urlPrefix + '/policy/manage/report/add',
    method: 'post',
    data
  })
}

/**
 * 行业报告管理-编辑
 * @param data
 */
export function reportUpdate(data) {
  return request({
    url: urlPrefix + '/policy/manage/report/update',
    method: 'post',
    data
  })
}

/**
 * 行业报告管理-删除
 * @param data
 */
export function reportDel(data) {
  return request({
    url: urlPrefix + '/policy/manage/report/del',
    method: 'post',
    data
  })
}
